import React, {Component} from 'react';
import {SessionHandler} from './SessionHandler';
import {Route,Redirect} from 'react-router-dom';

export default function ProtectedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        SessionHandler() ? (
          <Component {...rest}{...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}